var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "relative overflow-hidden", class: _vm.borderStyles },
    [
      _c(
        "Processing",
        {
          attrs: {
            backgroundOpacity: _vm.processingOpacity,
            processing: _vm.processing,
            overlayBlockClasses: _vm.borderStyles,
            spinner: "",
          },
        },
        [
          _c(
            "button",
            {
              staticClass:
                "flex items-center border border-transparent relative max-w-full button-ui",
              class: _vm.buttonClass,
              attrs: { type: _vm.type, id: _vm.id, disabled: _vm.isDisabled },
              on: {
                click: function ($event) {
                  return _vm.$emit("click")
                },
                mouseover: function ($event) {
                  _vm.isHovered = true
                },
                mouseout: function ($event) {
                  _vm.isHovered = false
                },
              },
            },
            [
              _vm.isIconSlotUsed
                ? _c(
                    "span",
                    {
                      staticClass: "flex items-center justify-center",
                      class: _vm.iconStyle,
                    },
                    [
                      !_vm.isHovered && !_vm.isDisabled
                        ? _vm._t("icon")
                        : _vm._e(),
                      _vm.isHovered && !_vm.isDisabled
                        ? _vm._t("hover-icon")
                        : _vm._e(),
                      _vm.isDisabled ? _vm._t("disabled") : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._t("default", function () {
                return [
                  _c(
                    "span",
                    {
                      staticClass: "whitespace-no-wrap truncate",
                      class: _vm.buttonTextStyle,
                    },
                    [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]
                  ),
                ]
              }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }